import { useQueryClient } from "@tanstack/react-query";

import { aiAgentQueryKeys } from "app/pages/sales-intelligence/modules/ai-agent/queries/queryKeyFactory";

export const useInvalidateContacts = (ids: string[]) => {
    const queryClient = useQueryClient();

    return async () => {
        await queryClient.invalidateQueries({ queryKey: aiAgentQueryKeys.superAgent.contacts(ids) });
    };
};
